import { ABSOLUTE_PAGE_URL } from '~~/types/components/AbsoluteUrl/AbsoluteUrlPage';
import type { DynamicPageContent } from '~~/types/cms/DynamicPageContent';
import { hasNativeRouteRedirection } from '~~/helpers/navigation/nativeRoutingRedirection';
import { SEO_REDIRECTION_CODE } from '~~/constants/seo';
import { buildCategoryPageUrl } from '~~/helpers/category/buildCategoryPageUrl';
import { addNativeRoutingToProductUrl } from '~~/helpers/routes/nativeRouting/transformProductsForNativeRouting';
import isStringTrue from '~~/helpers/dataStructure/isStringTrue';

const useNativeRoute = (
  absoluteUrlSlug: string,
  content: Ref<DynamicPageContent>,
) => {

  const { currentPage } = useAbsoluteUrlPage(content);
  const route = useRoute();
  const { countryCode } = useLocalization();

  const isRedirectionNeeded = computed(() => hasNativeRouteRedirection(countryCode.value));

  const makeCategoryRedirectionIfNeeded = () => {

    if (isRedirectionNeeded.value) {

      return {
        to: {
          path: buildCategoryPageUrl({
            category: absoluteUrlSlug,
            countryCode: countryCode.value,
          }),
          query: route.query,
        },
        redirectCode: SEO_REDIRECTION_CODE,
      };

    }

    return null;

  };

  const makePDPRedirectionIfNeeded = () => {

    if (isRedirectionNeeded.value) {

      return {
        to: {
          path: addNativeRoutingToProductUrl(absoluteUrlSlug, countryCode.value),
          query: route.query,
        },
        redirectCode: SEO_REDIRECTION_CODE,
      };

    }

    return null;

  };

  const makeNativeRouteRedirectionIfNeeded = () => {

    if (isStringTrue(process.env.ACTIVATE_NATIVE_AND_ABSOLUTE_PATHS_BOTH)) {

      return null;

    }

    if (currentPage.value === ABSOLUTE_PAGE_URL.pdp) {

      return makePDPRedirectionIfNeeded();

    } else if (currentPage.value === ABSOLUTE_PAGE_URL.categorySearch) {

      return makeCategoryRedirectionIfNeeded();

    }

    return null;

  };

  return {
    makeNativeRouteRedirectionIfNeeded,
  };

};

export default useNativeRoute;
